<!--
* @description  参数1
* @fileName  byTip
* @author userName
* @date 2024-01-23 10:21:40
!-->
<template>
  <div id="byTip" class="byTip" :style="[styleObject]">
    <div><i class="el-icon-warning"></i></div>
    <span>
        {{prompt}}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
    // 最大宽度
    width: {
      type: [String, Number],
      default: 128 + 'px',
    },
    height: {
      type: [String, Number],
      default: 544 + 'px',
    },
    // 字体颜色
    color: {
      type: [String, Number],
      default: '#EF0A0A',
    },
    // 字体大小
    fontSize: {
      type: [String],
      default: 13 + 'px',
    },
    background:{
        type: [String],
        default: '#EF0A0A',
    },
    textAlign:{
        type: [String],
        default: 'center',
    },
    prompt:{
        type:String,
        default:()=>{
            return ''
        }
    },
    // 自定义背景样式
    defineObj: {
      type: [Object],
      default: () => {
        return {
          def: {
            background: '',//背景颜色
            textAlign: '',
          }
        }
      },
    },
  },
  name: "byTip",
  data() {
    return {};
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
    styleObject() {
      return {
        "--width": this.width,//最大宽度
        "--height": this.height,//最大宽度
        "--font-size": this.fontSize,
        "--background-def": this.background,
        "--color":this.color,
        "--text-align-def": this.textAlign,
      }
    },
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.byTip{
    display: flex;
    width: var(--width);//308px;
    height: var(--height);//72px;
    background: var(--background-def);//rgba(239,10,10,0.04);
    border-radius: 4px;
    font-size: var(--font-size);//13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: var(--color);//#EF0A0A;
    padding: 8px;
    text-align: var(--text-align-def);//left;
    i{
        margin-right: 8px;
    }
}
</style>